import { userSelectors } from 'reducers';

export const types = {
    SEND_CO_SUBSCRIBER: 'SEND_CO_SUBSCRIBER',
    REQUEST_SEND_CO_SUBSCRIBER: 'REQUEST_SEND_CO_SUBSCRIBER',
    RECEIVE_SEND_CO_SUBSCRIBER: 'RECEIVE_SEND_CO_SUBSCRIBER',
    RECEIVE_SEND_CO_SUBSCRIBER_FAIL: 'RECEIVE_SEND_CO_SUBSCRIBER_FAIL',

    SEND_INVESTMENT_CHARACTERISTICS: 'SEND_INVESTMENT_CHAR',
    REQUEST_SEND_INVESTMENT_CHARACTERISTICS: 'REQUEST_SEND_INVESTMENT_CHAR',
    RECEIVE_SEND_INVESTMENT_CHARACTERISTICS: 'RECEIVE_SEND_INVESTMENT_CHAR',
    RECEIVE_SEND_INVESTMENT_CHARACTERISTICS_FAIL: 'RECEIVE_SEND_INVESTMENT_CHAR_FAIL',

    SET_SUCCESSFUL_UPDATE: 'SET_SUCCESSFUL_UPDATE',
    SET_TUNNEL_ERRORS: 'SET_TUNNEL_ERRORS',
    SET_CODE_VERIFIER: 'SET_CODE_VERIFIER',
    SET_INELIGIBILE: 'SET_INELIGIBILE',
    SET_SUBMIT_HANDLER: 'SET_SUBMIT_HANDLER',
    SET_FORM_CHANGES_VERIFIER: 'SET_FORM_CHANGES_VERIFIER',
    SET_VALIDATION_HANDLER: 'SET_VALIDATION_HANDLER',
    SET_CURRENT_INVESTMENT_FUND: 'SET_CURRENT_INVESTMENT_FUND',

    COMPLETE_SUBSCRIPTION_SIGNING_SESSION: 'COMPLETE_SUBSCRIPTION_SIGNING_SESSION',
    REQUEST_COMPLETE_SUBSCRIPTION_SIGNING_SESSION: 'REQUEST_COMPLETE_SUBSCRIPTION_SIGNING_SESSION',
    RECEIVE_COMPLETE_SUBSCRIPTION_SIGNING_SESSION: 'RECEIVE_COMPLETE_SUBSCRIPTION_SIGNING_SESSION',
    RECEIVE_COMPLETE_SUBSCRIPTION_SIGNING_SESSION_FAIL:
        'RECEIVE_COMPLETE_SUBSCRIPTION_SIGNING_SESSION_FAIL',

    COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION: 'COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION',
    REQUEST_COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION:
        'REQUEST_COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION',
    RECEIVE_COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION:
        'RECEIVE_COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION',
    RECEIVE_COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION_FAIL:
        'RECEIVE_COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION_FAIL',

    SEND_ATTESTATION_SUR_HONNEUR: 'SEND_ATTESTATION_SUR_HONNEUR',
    REQUEST_SEND_ATTESTATION_SUR_HONNEUR: 'REQUEST_SEND_ATTESTATION_SUR_HONNEUR',
    RECEIVE_SEND_ATTESTATION_SUR_HONNEUR: 'RECEIVE_SEND_ATTESTATION_SUR_HONNEUR',
    RECEIVE_SEND_ATTESTATION_SUR_HONNEUR_FAIL: 'RECEIVE_SEND_ATTESTATION_SUR_HONNEUR_FAIL',

    SEND_PERFORMANCE_PEDAGOGICAL_CONFIRM: 'SEND_PERFORMANCE_PEDAGOGICAL_CONFIRM',
    REQUEST_PERFORMANCE_PEDAGOGICAL_CONFIRM: 'REQUEST_PERFORMANCE_PEDAGOGICAL_CONFIRM',
    RECEIVE_PERFORMANCE_PEDAGOGICAL_CONFIRM: 'RECEIVE_PERFORMANCE_PEDAGOGICAL_CONFIRM',
    RECEIVE_PERFORMANCE_PEDAGOGICAL_CONFIRM_FAIL: 'RECEIVE_PERFORMANCE_PEDAGOGICAL_CONFIRM_FAIL',

    SEND_DISTRIBUTOR_KYC: 'SEND_DISTRIBUTOR_KYC',
    REQUEST_SEND_DISTRIBUTOR_KYC: 'REQUEST_SEND_DISTRIBUTOR_KYC',
    RECEIVE_SEND_DISTRIBUTOR_KYC: 'RECEIVE_SEND_DISTRIBUTOR_KYC',
    RECEIVE_SEND_DISTRIBUTOR_KYC_FAIL: 'RECEIVE_SEND_DISTRIBUTOR_KYC_FAIL',

    UPLOAD_ID_DOCUMENT: 'UPLOAD_ID_DOCUMENT',
    REQUEST_UPLOAD_ID_DOCUMENT: 'REQUEST_UPLOAD_ID_DOCUMENT',
    RECEIVE_UPLOAD_ID_DOCUMENT: 'RECEIVE_UPLOAD_ID_DOCUMENT',
    RECEIVE_UPLOAD_ID_DOCUMENT_FAIL: 'RECEIVE_UPLOAD_ID_DOCUMENT_FAIL',
};

export const actions = {
    sendCoSubscriber: (payload, callback, resubmit = false) => ({
        type: types.SEND_CO_SUBSCRIBER,
        payload,
        callback,
        resubmit,
    }),
    requestSendCoSubscriber: () => ({
        type: types.REQUEST_SEND_CO_SUBSCRIBER,
    }),
    receiveSendCoSubscriber: (resubmit = false) => ({
        type: types.RECEIVE_SEND_CO_SUBSCRIBER,
        resubmit,
    }),
    receiveSendCoSubscriberFail: error => ({
        type: types.RECEIVE_SEND_CO_SUBSCRIBER_FAIL,
        error,
    }),

    sendInvestmentCharacteristics: (investmentCharacteristics, callback) => ({
        type: types.SEND_INVESTMENT_CHARACTERISTICS,
        investmentCharacteristics,
        callback,
    }),
    requestSendInvestmentCharacteristics: () => ({
        type: types.REQUEST_SEND_INVESTMENT_CHARACTERISTICS,
    }),
    receiveSendInvestmentCharacteristics: () => ({
        type: types.RECEIVE_SEND_INVESTMENT_CHARACTERISTICS,
    }),
    receiveSendInvestmentCharacteristicsFail: error => ({
        type: types.RECEIVE_SEND_INVESTMENT_CHARACTERISTICS_FAIL,
        error,
    }),

    setSuccessfulUpdate: (value = false) => ({
        type: types.SET_SUCCESSFUL_UPDATE,
        value,
    }),

    setTunnelErrors: (errors = []) => ({
        type: types.SET_TUNNEL_ERRORS,
        errors,
    }),

    setCodeVerifier: (value = false) => ({
        type: types.SET_CODE_VERIFIER,
        value,
    }),

    setCurrentInvestmentFund: fund => ({
        type: types.SET_CURRENT_INVESTMENT_FUND,
        fund,
    }),

    setIneligible: ({
        open = false,
        message = '',
        subMessage = '',
        confirmMessage = '',
        abandon = true,
        canConfirm = false,
        title,
        hasDialogActions = true,
        onConfirm = null,
    }) => ({
        type: types.SET_INELIGIBILE,
        value: {
            open,
            message,
            subMessage,
            confirmMessage,
            abandon,
            canConfirm,
            title,
            hasDialogActions,
            onConfirm,
        },
    }),

    setSubmitHandler: (submitHandler = null) => ({
        type: types.SET_SUBMIT_HANDLER,
        submitHandler,
    }),

    setFormChangesVerifier: (changesVerifier = null) => ({
        type: types.SET_FORM_CHANGES_VERIFIER,
        changesVerifier,
    }),

    setValidationHandler: (validationHandler = null) => ({
        type: types.SET_VALIDATION_HANDLER,
        validationHandler,
    }),

    completeCoSubscriptionSigningSession: callback => ({
        type: types.COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION,
        callback,
    }),
    requestCompleteCoSubscriptionSigningSession: () => ({
        type: types.REQUEST_COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION,
    }),
    receiveCompleteCoSubscriptionSigningSession: () => ({
        type: types.RECEIVE_COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION,
    }),
    receiveCompleteCoSubscriptionSigningSessionFail: error => ({
        type: types.RECEIVE_COMPLETE_CO_SUBSCRIPTION_SIGNING_SESSION_FAIL,
        error,
    }),

    sendAttestationSurHonneur: (payload, callback) => ({
        type: types.SEND_ATTESTATION_SUR_HONNEUR,
        payload,
        callback,
    }),
    requestSendAttestationSurHonneur: () => ({
        type: types.REQUEST_SEND_ATTESTATION_SUR_HONNEUR,
    }),
    receiveSendAttestationSurHonneur: () => ({
        type: types.RECEIVE_SEND_ATTESTATION_SUR_HONNEUR,
    }),
    receiveSendAttestationSurHonneurFail: error => ({
        type: types.RECEIVE_SEND_ATTESTATION_SUR_HONNEUR_FAIL,
        error,
    }),

    sendUserAdequacy: (payload, callback, suspendCallback) => ({
        type: types.SEND_USER_ADEQUACY,
        payload,
        callback,
        suspendCallback,
    }),
    requestSendUserAdequacy: () => ({
        type: types.REQUEST_SEND_USER_ADEQUQCY,
    }),
    receiveSendUserAdequacy: () => ({
        type: types.RECEIVE_SEND_USER_ADEQUACY,
    }),
    receiveSendUserAdequacyFail: error => ({
        type: types.RECEIVE_SEND_USER_ADEQUACY_FAIL,
        error,
    }),

    sendRegulatoryDocuments: callback => ({
        type: types.SEND_REGULATORY_DOCUMENTS,
        callback,
    }),
    requestRegulatoryDocuments: () => ({
        type: types.REQUEST_REGULATORY_DOCUMENTS,
    }),
    receiveRegulatoryDocuments: () => ({
        type: types.RECEIVE_REGULATORY_DOCUMENTS,
    }),
    receiveRegulatoryDocumentsFail: error => ({
        type: types.RECEIVE_REGULATORY_DOCUMENTS_FAIL,
        error,
    }),

    sendPerformancePedagogicalConfirm: callback => ({
        type: types.SEND_PERFORMANCE_PEDAGOGICAL_CONFIRM,
        callback,
    }),
    requestPerformancePedagogicalConfirm: () => ({
        type: types.REQUEST_PERFORMANCE_PEDAGOGICAL_CONFIRM,
    }),
    receivePerformancePedagogicalConfirm: () => ({
        type: types.RECEIVE_PERFORMANCE_PEDAGOGICAL_CONFIRM,
    }),
    receivePerformancePedagogicalConfirmFail: error => ({
        type: types.RECEIVE_PERFORMANCE_PEDAGOGICAL_CONFIRM_FAIL,
        error,
    }),

    sendDistributorKYC: (payload, callback) => ({
        type: types.SEND_DISTRIBUTOR_KYC,
        payload,
        callback,
    }),
    requestDistributorKYC: () => ({
        type: types.REQUEST_SEND_DISTRIBUTOR_KYC,
    }),
    receiveDistributorKYC: () => ({
        type: types.RECEIVE_SEND_DISTRIBUTOR_KYC,
    }),
    receiveDistributorKYCFail: error => ({
        type: types.RECEIVE_SEND_DISTRIBUTOR_KYC_FAIL,
        error,
    }),

    uploadIdDocument: ({ stepId, payload }, callback) => ({
        type: types.UPLOAD_ID_DOCUMENT,
        payload,
        stepId,
        callback,
    }),
    requestUploadIdDocument: () => ({
        type: types.REQUEST_UPLOAD_ID_DOCUMENT,
    }),
    receiveUploadIdDocument: () => ({
        type: types.RECEIVE_UPLOAD_ID_DOCUMENT,
    }),
    receiveUploadIdDocumentFail: error => ({
        type: types.RECEIVE_UPLOAD_ID_DOCUMENT_FAIL,
        error,
    }),
};

const initialState = {
    stepEntries: [],
    shareCategories: [],
    shareSubcategories: [],
    errors: {},
    currentInvestmentFund: { id: 0, name: '', type: '' },
    changesVerifier: null, // custom function that checks for changes on a tunnel step form
    submitHandler: null, // custom function that submits the current tunnel step form
    validationHandler: null, // custom function that runs form validation on a tunnel step
    ineligible: {
        open: false,
        message: '',
        subMessage: '',
        abandon: true,
        hasDialogActions: true,
    },
    stepLoader: false,
    dataLoader: false,
    buttonLoader: false,
    investorLoader: false,
    successfulUpdate: false,
    showCodeVerifier: false,
    ashSendLoader: false,
};

const tunnel = (state, action) => {
    if (typeof state === 'undefined') return initialState;
    switch (action.type) {
        case types.REQUEST_SEND_CO_SUBSCRIBER:
            return { ...state, investorLoader: true };
        case types.RECEIVE_SEND_CO_SUBSCRIBER:
            return { ...state, investorLoader: false, showCodeVerifier: !action.resubmit };
        case types.RECEIVE_SEND_CO_SUBSCRIBER_FAIL:
            return { ...state, investorLoader: false };

        case types.REQUEST_SEND_INVESTMENT_CHARACTERISTICS:
            return { ...state, buttonLoader: true };
        case types.RECEIVE_SEND_INVESTMENT_CHARACTERISTICS:
            return { ...state, buttonLoader: false };
        case types.RECEIVE_SEND_INVESTMENT_CHARACTERISTICS_FAIL:
            return { ...state, buttonLoader: false };

        case types.SET_SUCCESSFUL_UPDATE:
            return { ...state, successfulUpdate: action.value };

        case types.SET_TUNNEL_ERRORS:
            return {
                ...state,
                errors: Object.fromEntries(action.errors.map(e => [e.property, e.message])),
            };

        case types.SET_CODE_VERIFIER:
            return { ...state, showCodeVerifier: action.value };

        case types.SET_INELIGIBILE:
            return { ...state, ineligible: action.value };

        case types.SET_SUBMIT_HANDLER:
            return { ...state, submitHandler: action.submitHandler };

        case types.SET_FORM_CHANGES_VERIFIER:
            return { ...state, changesVerifier: action.changesVerifier };

        case types.SET_VALIDATION_HANDLER:
            return { ...state, validationHandler: action.validationHandler };

        case types.REQUEST_SEND_ATTESTATION_SUR_HONNEUR:
            return { ...state, ashSendLoader: true };
        case types.RECEIVE_SEND_ATTESTATION_SUR_HONNEUR:
            return { ...state, ashSendLoader: false };
        case types.RECEIVE_SEND_ATTESTATION_SUR_HONNEUR_FAIL:
            return { ...state, ashSendLoader: false };

        case types.REQUEST_PERFORMANCE_PEDAGOGICAL_CONFIRM:
            return { ...state, buttonLoader: true };
        case types.RECEIVE_PERFORMANCE_PEDAGOGICAL_CONFIRM:
            return { ...state, buttonLoader: false };
        case types.RECEIVE_PERFORMANCE_PEDAGOGICAL_CONFIRM_FAIL:
            return { ...state, buttonLoader: false };

        case types.REQUEST_SEND_DISTRIBUTOR_KYC:
            return { ...state, buttonLoader: true };
        case types.RECEIVE_SEND_DISTRIBUTOR_KYC:
            return { ...state, buttonLoader: false };
        case types.RECEIVE_SEND_DISTRIBUTOR_KYC_FAIL:
            return { ...state, buttonLoader: false };

        case types.SET_CURRENT_INVESTMENT_FUND:
            return { ...state, currentInvestmentFund: action.fund };

        case types.REQUEST_SEND_SUBSCRIPTION_METHOD:
            return { ...state, buttonLoader: true };
        case types.RECEIVE_SEND_SUBSCRIPTION_METHOD:
            return { ...state, buttonLoader: false };
        case types.RECEIVE_SEND_SUBSCRIPTION_METHOD_FAIL:
            return { ...state, buttonLoader: false };

        case types.REQUEST_UPLOAD_ID_DOCUMENT:
            return { ...state, buttonLoader: true };
        case types.RECEIVE_UPLOAD_ID_DOCUMENT:
            return { ...state, buttonLoader: false };
        case types.RECEIVE_UPLOAD_ID_DOCUMENT_FAIL:
            return { ...state, buttonLoader: false };

        default:
            return state;
    }
};

const getInvestmentFundName = state => {
    const tunnelSubscription = userSelectors.getTunnelSubscription(state);
    return tunnelSubscription?.investmentFund?.name || '';
};

const getCurrentInvestmentFund = state => {
    const tunnelSubscription = userSelectors.getTunnelSubscription(state);
    return (
        tunnelSubscription?.investmentFund ||
        state.tunnel.currentInvestmentFund || { id: 0, name: '', type: '' }
    );
};

export const selectors = {
    getShareCategories: state => state.tunnel.shareCategories,
    getShareSubcategories: state => state.tunnel.shareSubcategories,
    getInvestmentFundName,
    getTunnelErrors: state => state.tunnel.errors,
    getStepLoader: state => state.tunnel.stepLoader,
    getButtonLoader: state => state.tunnel.buttonLoader,
    getInvestorLoader: state => state.tunnel.investorLoader,
    getDataLoader: state => state.tunnel.dataLoader,
    getIneligibleStatus: state => state.tunnel.ineligible,
    getSuccessfulUpdate: state => state.tunnel.successfulUpdate,
    getShowCodeVerifier: state => state.tunnel.showCodeVerifier,
    getSubmitHandler: state => state.tunnel.submitHandler,
    getFormChangesVerifier: state => state.tunnel.changesVerifier,
    getValidationHandler: state => state.tunnel.validationHandler,
    getAshSendLoader: state => state.tunnel.ashSendLoader,
    getCurrentInvestmentFund,
};

export default tunnel;
